import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import { PoliciesRootPath } from 'utils/constants/routes';
import FatsomaTabbLogo from 'utils/images/fatsoma-tabb-logo.svg';
import './index.scss';
import Terms from './Terms';

const Policies = () => {
  return (
    <div className="policies__page__container">
      <div className="policies__nav__bar">
        <img src={FatsomaTabbLogo} alt="Logo" className="policies__logo" />
        <h3 style={{ padding: 0, margin: 0, color: 'white' }}>Policies</h3>
      </div>

      <div className="policies__page__content">
        <Router>
          <Switch>
            <Route path={`${PoliciesRootPath}/terms`} component={Terms} />
          </Switch>
        </Router>
      </div>
    </div>
  );
};

export default withRouter(Policies);



// WEBPACK FOOTER //
// ./src/components/Policies/index.jsx